import { ActionCreator } from 'redux';
import { ApplicationState } from '..';
import { BillingPlan, ProductCode } from '@dev/ee-api/ee-api-models';
import {
    DashboardProduct,
    ProductActionTypes,
    ProductGetListStart,
    ProductGetListSuccess,
    ProductGetListError,
    ProductListState,
    BillingPlansLoaded,
    LoadingBillingPlansError,
    LoadBillingPlans,
    ChangeProductAction,
} from './types';
import { GoogleAnalyticsEventsEnum } from '@api/services/dictionaries/GoogleAnalyticsEvents';

export const LoadProductList: ActionCreator<ProductGetListStart> = (): ProductGetListStart => ({
    type: ProductActionTypes.LOAD_PRODUCT_LIST,
});

export const ProductListLoaded: ActionCreator<ProductGetListSuccess> = (dashboards: DashboardProduct[]): ProductGetListSuccess => ({
    type: ProductActionTypes.LOAD_PRODUCT_LIST_SUCCESS,
    payload: {
        dashboards,
    },
});

export const ProductListLoadingError: ActionCreator<ProductGetListError> = (): ProductGetListError => ({
    type: ProductActionTypes.LOAD_PRODUCT_ERROR,
});

export const PlansLoaded = (billingPlans: BillingPlan[]): BillingPlansLoaded => ({
    type: ProductActionTypes.BILLING_PLANS_LOADED,
    payload: {
        billingPlans,
    },
});

export const PlansLoadingError = (): LoadingBillingPlansError => ({
    type: ProductActionTypes.LOADING_BILLING_PLANS_ERROR,
});

export const GetBillingPlans = (billingPlanCode: ProductCode): LoadBillingPlans => ({
    type: ProductActionTypes.LOAD_BILLING_PLANS,
    payload: {
        billingPlanCode,
    },
});

// additional eventLabel payload parameter to remove after A/B tests
export const ChangeProduct = (billingPlanID: number, defaultTier: number, eventLabel?: GoogleAnalyticsEventsEnum): ChangeProductAction => ({
    type: ProductActionTypes.CHANGE_PRODUCT,
    payload: {
        billingPlanID,
        defaultTier,
        eventLabel,
    },
});

export const getProductStore = (state: ApplicationState): ProductListState => state.products;
export const getDashboards = (store: ApplicationState): DashboardProduct[] => store.products?.dashboards;
export const getBillingPlanList = (store: ApplicationState): BillingPlan[] => store.products?.billingPlans;
export const getProductCode = (store: ApplicationState) => store.products?.dashboards?.[0]?.Code;
